/**
 * @license Givaudan. All rights reserved. This
 * @author Omar BERRABEH
 */

import { DOCUMENT } from '@angular/common';
import { Injector } from '@angular/core';
import { AccountService } from '@banyan/modules/account/services/account.service';
import { environment } from '@env/environment';
import { AuthConfig, OAuthService } from 'angular-oauth2-oidc';

export function authInitializer(
  injector: Injector,
  oauthService: OAuthService,
  accountService: AccountService
): () => Promise<void> {
  return async () => {
    try {
      const origin =
        injector.get(DOCUMENT).defaultView?.origin ?? environment.domain;
      const authOriginal = environment.auth;
      const auth: AuthConfig = {
        ...authOriginal,
        redirectUri: `${origin}${authOriginal.redirectUri}`,
        postLogoutRedirectUri: `${authOriginal.postLogoutRedirectUri}`,
      };
      oauthService.configure(auth);
      await oauthService.loadDiscoveryDocument();
      oauthService.setupAutomaticSilentRefresh();
      accountService.checkLoginStatus();
    } catch (e) {
      // eslint-disable-next-line no-console
      console.log('error when initializing auth', e);
    }
  };
}
